<template>
  <div>
    <div class="detailed-info">
      <div class="detailed-info__block-1">
        <div class="detailed-info-device">
          <v-col cols="12" sm="12" class="pb-0">
            <div>
              <v-img
                height="280"
                contain
                class="image-gate border mt-2"
                :src="require('../../../../../public/controllerRacs.png')"
                @click="zoomPhoto(require('../../../../../public/controllerRacs.png'))">
              </v-img>
            </div>
            <v-dialog v-model="showZoomPhoto" :max-width="isMobile ? '90%' : '50%'" @input="closeZoomPhoto">
              <zoom-photo
                v-model="showZoomPhoto"
                :photo="currentZoomPhoto"
                @closeZoomPhoto="closeZoomPhoto()"
              >
              </zoom-photo>
            </v-dialog>
          </v-col>
          <v-col class="detailed-info-device__box-2">
            <detailed-info
              :gate="gate"
              :is-check-size-small="isCheckSizeSmall"
            />
          </v-col>
          <v-col cols="12" sm="12" class="detailed-info-device__box-3">
            <v-card class="border card-info-clue">
              <v-carousel
                :cycle="roleName !== 'admin'"
                interval="8000"
                show-arrows-on-hover
                height="400"
                hide-delimiter-background
              >
                <v-carousel-item>
                  <v-sheet color="#4C6C93" height="100%">
                    <div class="pa-6">
                      <h1 class="info-warning">
                        <div>
                          <div v-for="(item, index) in statistics" :key="index">
                            <statistic-label-info
                              :label="item.label"
                              :value="item.value"
                              :check="item.check"
                              :icon="item.icon"
                              :br-check="item.brCheck"
                              :to="item.to"
                              :is-router-link="item.isRouterLink"
                              :is-check-size-small="isCheckSizeSmall"
                            />
                          </div>
                          <div>
                            <h4 class="h4-statistics-device">Устройство</h4>
                            <p>ip-адрес: {{ gate.device.ip_address }}</p>
                            <p>Производитель: {{ gate.device.manufacturer }}</p>
                            <p>Модель: {{ gate.device.model }}</p>
                            <p v-if="gate.device.mac_address">Mac-address: {{ gate.device.mac_address }}</p>
                          </div>
                        </div>
                      </h1>
                    </div>
                    <div style="position: absolute; bottom: 15px; right: 15px;">
                      <v-icon style="font-size: 50px; height: inherit;" color="#87A1B9">mdi-information-outline</v-icon>
                    </div>
                  </v-sheet>
                </v-carousel-item>
                <v-carousel-item v-for="(slide, i) in slides" :key="i">
                  <v-sheet :color="slide.color" height="100%">
                    <div class="pa-6">
                      <h1 class="info-warning">
                        <div v-html="slide.title" />
                      </h1>
                    </div>
                    <div style="position: absolute; bottom: 15px; right: 15px;">
                      <v-icon style="font-size: 50px; height: inherit;" :color="slide.colorIcon">{{ slide.icon }}</v-icon>
                    </div>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
            </v-card>
          </v-col>
        </div>
      </div>
      <div class="detailed-info__block-2">
        <v-row no-gutters>
          <v-col cols="12" sm="11" class="mt-4" style="cursor: pointer;">
            <div
              v-for="page in pageStore"
              :key="page.title"
              class="hover-scale-effect"
            >
              <v-card
                class="border card-info-btn"
                :color="page.colorCard"
                :class="{'disabled' : page.isDisabled }"
                v-if="page.show"
                @click="page.click"
              >
                <div style="display: flex; height: 100%">
                  <v-card style="border-radius: 16px; width: 35%; height: 100%; text-align: center;" :color="page.colorCardIcon">
                    <v-icon style="font-size: 40px; height: inherit;" color="white">{{ getIcon(page) }}</v-icon>
                  </v-card>
                  <div class="btn-page-store" v-html="page.title" />
                </div>
              </v-card>
            </div>
          </v-col>
          <v-dialog v-model="dialogBuyGate" max-width="900" content-class="dialog-border-radius">
            <NewKeyModal
              :active.sync="dialogBuyGate"
              @close="dialogBuyGate = false"
              header="Продажа ключей от калитки (колясочная)"
              header-mobile="Продажа ключей"
              icon="mdi-account-key-outline"
              @submit="getData"
              :basic-info-devices="basicInfoGates"
            />
          </v-dialog>
        </v-row>
      </div>
    </div>
    <v-row no-gutters class="pb-4 mt-2">
      <v-col cols="12" sm="12" md="7" lg="7">
        <v-card v-if="gate.doorphones[0]" class="border info-additional">
          <div class="pa-4 tied">
            <p v-if="gate.doorphones[0]">
              Привязанные домофоны:
              <template v-for="(tmp, index) of displayedIntercoms">
                <router-link class="routerLink" v-bind:key="tmp.id" :to="`/doorphones/${tmp.id}`">
                  Домофон №{{ tmp.id }}
                </router-link>
                <template v-if="index !== gate.doorphones.length - 1">,</template>
              </template>
              .
              <span v-show="gate.doorphones.length > 4" class="ml-2">
                  <v-btn @click="toggleIntercoms">
                    <v-icon>{{ showAllIntercoms ? 'mdi-chevron-triple-left' : 'mdi-chevron-triple-right' }}</v-icon>
                  </v-btn>
                </span>
            </p>
          </div>
        </v-card>
      </v-col>
      <v-col class="col-btn-additional">
        <div
          v-for="page in additionalButtons"
          :key="page.title"
          style="display: flex"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="page.show"
                :color="page.colorCard"
                class="border card-footer-button hover-scale-effect"
                v-bind="attrs"
                v-on="on"
                :disabled="page.isDisabled"
                @click="page.click"
                style=""
              >
                <v-icon style="font-size: 40px; height: inherit;" color="white">{{ getIcon(page) }}</v-icon>
              </v-btn>
            </template>
            <span>{{ page.title }}</span>
          </v-tooltip>
        </div>
      </v-col>
      <v-dialog v-model="detailDialog" max-width="800" content-class="dialog-border-radius">
        <DetailDeviceModal
          :active.sync="detailDialog"
          @close="detailDialog = false"
          :device="gate.device"
        />
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DetailDeviceModal from '../../../device/DetailDeviceModal.vue';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import StatisticLabelInfo from '@/components/StatisticLabelInfo.vue';
import zoomPhoto from '@/components/client/DetailClient/components/zoomPhoto.vue';
import NewKeyModal from '@/components/gate/DetailGate/components/NewKeyModal.vue';
import DetailedInfo from './GeneralInfo/components/DetailedInfo.vue';

export default {
  props: {
    getData: Function,
  },
  components: {
    DetailedInfo,
    zoomPhoto,
    StatisticLabelInfo,
    DetailDeviceModal,
    NewKeyModal,
  },
  mixins: [ruDateFormatMixin],
  name: 'GeneralInfo',
  data () {
    return {
      streamUrl: '',
      detailDialog: false,
      channel: {
        id: this.$route.params.id,
        address: '',
        streamUrl: '',
        link: '',
      },
      snapshot: null,
      hls: null,
      activeButton: null,
      showZoomPhoto: false,
      currentZoomPhoto: '',
      loading: false,
      isMobile: false,
      dialogImage: false,
      isFirstTimeDialogImageOpened: false,
      disableRoleNameAdmin: false,
      isErrorStreamUrl: false,
      dialogBuyGate: false,
      videoLoader: true,
      disableRoleName: false,
      isCheckSizeSmall: false,
      isUpdatedSip: false,
      dialogImagePlayer: false,
      showAllIntercoms: false,
      basicInfoDevices: [],
      allAbonents: '',
      allTemporarySubscribers: '',
      allNumbersCars: '',
    };
  },
  created () {
    switch (this.roleName) {
      case 'admin': case 'admin-engineer' : this.disableRoleName = true;
        break;
    }
    switch (this.roleName) {
      case 'admin' : this.disableRoleNameAdmin = true;
        break;
    }
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  computed: {
    ...mapGetters({
      gate: 'Gate/gate',
      roleName: 'roleName',
    }),
    displayedIntercoms () {
      return this.showAllIntercoms ? this.gate.doorphones : this.gate.doorphones.slice(0, 4);
    },
    slides () {
      return [
        {
          title: 'Калитка может быть оборудована различными типами доступа.<br><br>Например, вы можете выбрать доступ' +
            'по ключ-карте, коду или через приложение, что делает ее удобной для входа и выхода.',
          color: '#1f3965',
          colorIcon: '#87A1B9',
          icon: 'mdi-lock-outline',
        },
        {
          title: 'Учтите особенности калиток для колясочных.<br><br>Эти калитки рассчитаны на широкие входы и удобный' +
            'проход с коляской. Проверьте доступность и правильную настройку таких устройств для пользователей.',
          color: '#fd7b7b',
          colorIcon: '#87A1B9',
          icon: 'mdi-information-outline',
        },
        {
          title: 'Учитывайте роль управляющей компании в обслуживании калитки.<br><br>Обслуживание и ремонт калиток' +
            'осуществляются только специализированными компаниями. Все заявки направляются им.',
          color: '#673AB7',
          colorIcon: '#87A1B9',
          icon: 'mdi-briefcase-outline',
        },
      ];
    },
    basicInfoGates () {
      return [
        { label: 'Калитка', value: ` № ${this.gate.id}`, check: '1' },
        { label: 'Город', value: this.gate.address.split(' ')[0], check: this.gate.address },
        { label: 'Район', value: this.gate.region_name, check: this.gate.region_name },
        { label: 'Адрес', value: this.gate.address, check: this.gate.address },
      ];
    },
    additionalButtons () {
      return [
        {
          title: 'Редактировать',
          color: '#1E6CEB',
          icon: 'mdi-pencil',
          colorCard: '#1E6CEB',
          show: true,
          click: this.getEditGate,
          isDisabled: !this.$checkPermission('edit_gate'),
        },
        {
          title: 'Открыть дверь',
          color: 'success',
          icon: 'mdi-location-exit',
          colorCard: '#85B285',
          show: true,
          click: this.openDeviceClick,
          isDisabled: !this.$checkPermission('open_gate'),
        },
        {
          title: 'Информация о устройстве',
          color: '#1E6CEB',
          icon: 'mdi-information-outline',
          colorCard: '#4C6C93',
          click: this.openDetailDialogDevice,
          show: true,
          isDisabled: !this.$checkPermission('view_device'),
        },
      ];
    },
    pageStore () {
      return [
        {
          title: 'Продажа ключей от калитки<br>(колясочная)',
          color: '#1E6CEB',
          icon: 'mdi-account-key-outline',
          colorCard: 'rgba(172, 204, 172, 0.5)',
          colorCardIcon: '#85B285',
          isDisabled: !this.$checkPermission('create_key_gate'),
          show: true,
          click: this.openDialogBuyGate,
        },
      ];
    },
    statistics () {
      return [
        { label: 'Кол-во ключей', value: this.gate.keys.length, check: '1' },
        { label: 'Кол-во Домофонов', value: this.gate.doorphones.length, check: '1' },
      ];
    },
    displayTitle () {
      return 'Калитка';
    },
  },
  mounted () {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    }
  },
  methods: {
    ...mapActions({
      openDorGate: 'Gate/openGate',
    }),
    openDialogBuyGate () {
      this.dialogBuyGate = true;
    },
    toggleIntercoms () {
      this.showAllIntercoms = !this.showAllIntercoms;
    },
    getIcon (page) {
      return this.activeButton === page.title ? page.iconHover : page.icon;
    },
    openDetailDialogDevice () {
      this.detailDialog = true;
    },
    transitionWebDevice () {
      const hrefDevice = `http://${this.gate.device.ip_address}.intercom.access.simdev.ru/`;
      window.open(hrefDevice, '_blank');
    },
    zoomPhoto (photo) {
      this.currentZoomPhoto = photo;
      this.showZoomPhoto = true;
    },
    closeZoomPhoto () {
      this.showZoomPhoto = false;
      this.currentZoomPhoto = null;
    },
    getSipStatus (status) {
      switch (status) {
        case '2' : return '(Зарегестрировано)';
        default: return '(Не в сети)';
      }
    },
    openDeviceClick () {
      this.openDorGate(this.$route.params.id)
        .then(() => {
          this.$flash_success('Открыто!');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при открытии');
        });
    },
    checkSize () {
      this.isCheckSizeSmall = window.innerWidth <= 600;
    },
    getEditGate () {
      this.$router.push({ name: 'EditGate', params: { id: this.$route.params.id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: cornflowerblue;
}

a:hover.routerLink {
  text-decoration: underline;
}
.row-click {
  cursor: pointer;
}

.image-gate {
  cursor: pointer;
}
.action-list {
  border: 1px solid #1976d2;
  border-radius: 4px;
}
.hist-but {
  cursor: pointer;
  color: cornflowerblue;
}
.gate-info, .gate-info {
  color: rgba(0, 0, 0, 0.87);
}
.information p {
  margin-bottom: 4px;
}
.sip-history-header {
  position: sticky;
  top: 0;
  z-index: 999;
}
.action-container {
  text-align: -webkit-center;
}
.abonent-table-title {
  padding-top: 20px;
  padding-left: 30px;
}
@media screen and (max-width: 600px) {
  .action-column {
    display: inline-grid !important;
  }
  .gate-info-one, .gate-info-two {
    padding-left: 0;
    margin-left: 0;
  }
}
 //----------

.intercom-info {
  font-weight: 400 !important;
  padding-left: 15px;
  font-size: 16px;
}

.border {
  border-radius: 16px;
}
.information p {
  margin-bottom: 4px;
}

.v-application p {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 17px;
  font-family: 'Montserrat', sans-serif;
}

@media screen and (max-width: 1500px) {
  .v-application p {
    font-size: 16px
  }
  .apex-chart {
    height: auto;
  }
}
</style>
